import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { companyApis } from './apis/balanceApi';

export const store = configureStore({
    reducer: Object.fromEntries(
        Object.values(companyApis).map(api => [api.reducerPath, api.reducer]),
    ),
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware().concat(
            ...Object.values(companyApis).map(api => api.middleware)
        ),
});

setupListeners(store.dispatch);


